import React from "react";
import { Button, ButtonGroup } from "reactstrap";
import { LinkContainer } from "react-router-bootstrap";
import "./MobilFooter.scss";

const MobilFooter = () => {
  return (
    <ButtonGroup className="w-100  d-md-none mobil-footer">
      <LinkContainer to="/ukoly/nevyrizene">
        <Button className="p-4" block>
          Nevyřízené
        </Button>
      </LinkContainer>
      <LinkContainer to="/ukoly/historie">
        <Button className="p-4 mt-0" block>
          Historie
        </Button>
      </LinkContainer>
    </ButtonGroup>
  );
};

export default MobilFooter;
